/**
 * layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"

import "bootstrap/dist/css/bootstrap.css"
import "magnific-popup/dist/magnific-popup.css"
import "../../styles/LineIcons.css"
import "../../styles/main.css"
import "../../styles/responsive.css"

import "jquery"
import "bootstrap/dist/js/bootstrap"
import Main from "./main"

import Header from "../header"
import Footer from "../footer"

class Layout extends React.Component {

  componentDidMount() {
    require("jquery-countdown");
    Main();
  }

  render() {
    const {children} = this.props

    return (
      <>
        <Header {...this.props} />
        <main>{children}</main>
        <Footer />
        <button className="back-to-top">
          <i className="lni-chevron-up"></i>
        </button>
      </>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
